"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en-US">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          background: "#0A0A0A",
          color: "#F2F0EC",
          fontFamily: "system-ui, sans-serif",
          display: "grid",
          placeItems: "center",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 480 }}>
          <h1
            style={{
              fontSize: "clamp(2rem, 5vw, 3rem)",
              textTransform: "uppercase",
              letterSpacing: "-0.02em",
              fontWeight: 900,
              margin: 0,
              lineHeight: 0.95,
            }}
          >
            We hit a wall.
          </h1>
          <p
            style={{
              marginTop: 16,
              fontSize: 14,
              opacity: 0.7,
              fontFamily: "ui-monospace, monospace",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
            }}
          >
            {error.digest ?? "fatal error"}
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: 28,
              background: "#C8102E",
              color: "#F2F0EC",
              border: 0,
              padding: "12px 24px",
              fontSize: 13,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              cursor: "pointer",
              fontWeight: 800,
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
